export type FieldErrors = Record<string, string>;

export function toUserMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message.trim().length > 0) {
    return error.message;
  }

  return fallback;
}

export function toFieldErrors(error: unknown): FieldErrors {
  const result: FieldErrors = {};

  if (
    typeof error === "object" &&
    error !== null &&
    "issues" in error &&
    Array.isArray(error.issues)
  ) {
    for (const issue of error.issues) {
      const path = Array.isArray(issue.path) ? issue.path.join(".") : "";

      if (path && typeof issue.message === "string") {
        result[path] = issue.message;
      }
    }
  }

  return result;
}

export function isAbortError(error: unknown): boolean {
  return error instanceof DOMException && error.name === "AbortError";
}
